<div class="image-body">
  <img [attr.src]="imageURL" />
</div>
